"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VacanciesTitle = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const enums_1 = require("@bemlo/enums");
const schedule_1 = require("@bemlo/schedule");
const utils_1 = require("@bemlo/utils");
const constants_1 = require("../../../../constants");
const elements_1 = require("../../../../elements");
const translate_1 = require("../../../../translate");
const shift_hours_styles_1 = require("../../../../utils/shift-hours-styles");
const useSchedule_1 = require("../useSchedule");
const Container = (0, styled_1.default)(elements_1.Flex)(({ selected }) => ({
    flexDirection: 'column',
    gap: 1,
    paddingTop: constants_1.theme.spacing[1],
    paddingBottom: constants_1.theme.spacing[1],
    paddingRight: constants_1.theme.spacing[2],
    paddingLeft: constants_1.theme.spacing[2],
    height: '100%',
    position: 'relative',
    '.checkbox': {
        display: selected ? 'block' : 'none',
    },
    ':hover': {
        '.checkbox': {
            display: 'block',
        },
    },
}));
const PropertyBadge = styled_1.default.div({
    background: constants_1.Color.LIGHT_GREY,
    border: `0.5px solid ${constants_1.Color.MEDIUM_GREY}`,
    color: constants_1.Color.DARKEST_MEDIUM_GREY,
    borderRadius: 4,
    padding: `0px 4px`,
    fontSize: 11,
    fontWeight: constants_1.theme.font.weight.book,
    display: 'flex',
    alignItems: 'center',
    gap: 3,
    letterSpacing: '0.5px',
});
const SaveBadge = (0, styled_1.default)(elements_1.Div)({
    position: 'absolute',
    top: 0,
    right: 0,
    fontWeight: constants_1.theme.font.weight.book,
    padding: `${constants_1.theme.spacing['0.5']}px`,
    lineHeight: 1,
});
const VacanciesTitle = (props) => {
    const t = (0, translate_1.useTranslations)();
    const { allShiftsSelected, toggleSelected, enableSelectShifts } = (0, useSchedule_1.useSelectedShifts)(props.shiftIds);
    const shift = {
        activity: enums_1.ShiftActivity.WORK,
        breakTime: props.breakTime,
        endTime: props.endTime,
        startTime: props.startTime,
        date: props.startDate,
        comment: props.comment,
        onCallTime: props.onCallTime,
    };
    const shiftHoursDesign = props.shiftHours && shift_hours_styles_1.SHIFT_HOURS_STYLES[props.shiftHours];
    const time = (0, schedule_1.shiftWorkDuration)(shift);
    const workHours = time.shift.subtract(time.break);
    const numberOfShifts = props.shiftIds.length;
    const breakBadge = props.showBreakBadge ? ((0, jsx_runtime_1.jsxs)(PropertyBadge, { children: [(0, jsx_runtime_1.jsx)(elements_1.Icon, { name: "CoffeeIcon", size: "xs", design: "solid" }), props.breakTime, "m"] })) : null;
    const commentBadge = props.comment ? ((0, jsx_runtime_1.jsx)(PropertyBadge, { children: (0, jsx_runtime_1.jsx)(elements_1.Icon, { name: "AnnotationIcon", size: "xs", design: "solid" }) })) : null;
    const tagsBadge = props.tags?.length ? ((0, jsx_runtime_1.jsxs)(PropertyBadge, { children: [(0, jsx_runtime_1.jsx)(elements_1.Icon, { name: "TagIcon", size: "xs", design: "solid" }), props.tags.length] })) : null;
    const onCallTimeBadge = props.onCallTime ? ((0, jsx_runtime_1.jsxs)(PropertyBadge, { children: [t.$date.formatDuration({ hours: time.onCall.asHours() }), ' ', t.$onCallTypeAbbreviation(props.onCallTime.type)] })) : null;
    const hasBadges = !!breakBadge || !!commentBadge || !!tagsBadge || !!onCallTimeBadge;
    return ((0, jsx_runtime_1.jsxs)(Container, { selected: allShiftsSelected, children: [!!numberOfShifts && ((0, jsx_runtime_1.jsx)(elements_1.Text, { color: constants_1.Color.DARK_GREY, fontSize: constants_1.theme.font.size[6.5], fontWeight: constants_1.theme.font.weight.book, children: props.title ?? t.shifts.vacant_other() })), (0, jsx_runtime_1.jsxs)(elements_1.Flex, { children: [(0, jsx_runtime_1.jsxs)(elements_1.Text, { fontSize: constants_1.theme.font.size[6.5], color: allShiftsSelected ? constants_1.Color.MEDIUM_BLUE : constants_1.Color.DARK_GREY, bold: true, children: [props.startTime, " - ", props.endTime] }), enableSelectShifts && !!numberOfShifts && ((0, jsx_runtime_1.jsx)(elements_1.Div, { className: "checkbox", styles: { position: 'relative' }, children: (0, jsx_runtime_1.jsx)(elements_1.Checkbox, { styles: { ml: 1.5, position: 'absolute' }, size: "sm", checked: allShiftsSelected, onChange: toggleSelected }) }))] }), (0, jsx_runtime_1.jsx)(elements_1.Text, { fontSize: constants_1.theme.font.size['6.5'], color: constants_1.Color.DARKEST_MEDIUM_GREY, fontWeight: constants_1.theme.font.weight.book }), hasBadges && ((0, jsx_runtime_1.jsxs)(elements_1.Flex, { gap: 1, styles: { mb: 1.5 }, children: [breakBadge, commentBadge, tagsBadge, onCallTimeBadge] })), !!numberOfShifts && shiftHoursDesign && ((0, jsx_runtime_1.jsxs)(elements_1.Flex, { gap: 1, children: [(0, jsx_runtime_1.jsx)(elements_1.Icon, { name: shiftHoursDesign.icon, size: "sm", color: shiftHoursDesign.color }), (0, jsx_runtime_1.jsx)(elements_1.Text, { color: shiftHoursDesign.color, fontSize: constants_1.theme.font.size['6.5'], children: numberOfShifts
                            ? t.$date.formatDuration({
                                hours: workHours.asHours() * numberOfShifts,
                            })
                            : `0 ${t.shifts.shift_other().toLocaleLowerCase()}` })] })), (0, utils_1.isTruthy)(props.persisted) && ((0, jsx_runtime_1.jsx)(SaveBadge, { children: (0, jsx_runtime_1.jsx)(elements_1.Tooltip, { side: "right", text: props.persisted.id
                        ? t.shifts.remove_fixed()
                        : t.shifts.make_fixed(), children: (0, jsx_runtime_1.jsx)(elements_1.Tooltip.Trigger, { asChild: true, children: (0, jsx_runtime_1.jsx)(elements_1.Clickable, { onClick: props.persisted.onClickSave, children: (0, jsx_runtime_1.jsx)(elements_1.Icon, { name: "BookmarkIcon", size: "sm", design: props.persisted.id ? 'solid' : 'outline', color: props.persisted.id ? constants_1.Color.BLUE : constants_1.Color.DARK_MEDIUM_GREY }) }) }) }) }))] }));
};
exports.VacanciesTitle = VacanciesTitle;
